import React from 'react';
import { Box } from '@mui/material';
// import AppBanner from "../../assets/img/AppBanner.png";
import AppBanner from "../../assets/img/bannerImg2.jpg";
import { useTheme } from "@mui/material/styles";
function Appbanner() {
const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor:theme.palette.primary.light,
        // backgroundColor:'#C7E7FF',
        width: '95%',
        height: '550px',
        padding:"2vw",
        margin:'auto',
      }}
    >
      <Box
        sx={{
          backgroundImage: `url(${AppBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '70%', 
          height: '98%', 
          boxShadow: 8,
        }}
      />
    </Box>
  );
}

export default Appbanner;
